export enum QuestionnaireRequestType {
  SELF_REPORT = 'SELF_REPORT', // Can be taken whenever
  SCHEDULED = 'SCHEDULED', // Scheduled without compliance - freq 1
  COMPLIANCE = 'COMPLIANCE', // Scheduled with compliance - freq 1
}
